import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getQuizContent, postAnswers } from "./QuizAPI";

type JSONValue = string | number | boolean | Array<any>;

interface JSONObject {
  [key: string]: JSONValue;
}

function useQuizContent(id: Number) {
  return useQuery<any, Error>(
    ["quiz-content-" + id],
    () => getQuizContent(id),
    {}
  );
}


function useSaveAnswersMutation(
  setHasSuccessfullySubmitted: Function,
  setFieldError: Function,
  setFieldErrorText: Function
) {

  return useMutation((answers: JSONObject) => postAnswers(answers), {
    onSuccess: (res) => {
      setHasSuccessfullySubmitted(true)
    },
    onError: async (error: any) => {
      setFieldError(true);
      setFieldErrorText("Something went wrong. Please try again!");
    },
  });
}

export { useQuizContent, useSaveAnswersMutation};
